<template>
    <div>
        <eco-header :step_num="4" />
        <b-row>
            <b-col class="text-right">
                Всего точек :
                <hr />
            </b-col>
            <b-col>
                {{ pointsCount }}
                <hr />
            </b-col>
        </b-row>
        <b-row v-for="(item, index1) of points" :key="index1">
            <b-col class="text-right">
                <b-row v-for="(name, index2) of names" :key="index2"  style="padding-top:8px" align-v="center">
                    <b-col class="text-right" cols="12" md="4">
                        {{ titles[name] }}:
                    </b-col>
                    <b-col cols="12" md="8">
                        <b-input v-model="item[name]" @keyup="updateStore" :state="item.done ? item.done[name] : null"/>
                    </b-col>
                </b-row>
                <b-button v-if="index1 > 0" @click="removePoint(index1)" variant="link-danger">Удалить</b-button>
                <hr />
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-right" cols="12" md="4">
                Если у Вас более одной адресной точки, то: 
            </b-col>
            <b-col cols="12" md="8">
                <b-button @click="addNewPoint" variant="outline-success" block>Добавить еще одну точку [ + ]</b-button>
            </b-col>
        </b-row>
        <eco-footer :step_num="4" :allow_next="allowNext"/>
    </div>
</template>

<script>
import { emptyPoint } from '../company_class.js'

export default {
    data() {
        return {
            names: ['name', 'address', 'type'],
            allowNext: false,
            spinner: false,
            points: [ ],
            empty: null,
            titles: null
        }
    },
    mounted() {
        this.points = this.$store.getters.COMPANY ? this.$store.getters.COMPANY.points : []
        this.titles = this.$store.getters.TITLES ? this.$store.getters.TITLES.points[0] : []
        this.checkPoints()
    },
    methods: {
        checkPoints() {
            let _allowNext = this.points && this.points.length > 0 ? true : false
            for(let point of this.points) {
                for(let name of this.names) {
                    if(!point.done) point.done = {}
                    point.done[name] = true
                    if(!point[name] || (point[name] && point[name].length < 1)) {
                        point.done[name] = false
                        _allowNext = false
                    }
                }
            }
            this.allowNext = _allowNext
        },
        addNewPoint() {
            this.points.push(emptyPoint())
            this.updateStore()
        },
        removePoint(index) {
            let res = []
            for(let i = 0; i < this.points.length; i++){
                if(i != index) {
                    res.push(this.points[i])
                }
            }
            this.points = res
            this.updateStore()
        },

        updateStore() {
            this.checkPoints()
            this.$store.dispatch('SET_POINTS', this.points)
        }
    },
    computed:{
        pointsCount(){
            return this.$store.getters.COMPANY ? this.$store.getters.COMPANY.points.length : 'n/d'
        }
    }
}
</script>